import { render, staticRenderFns } from "./activityResultsTable.vue?vue&type=template&id=4a50f0c6"
import script from "./activityResultsTable.vue?vue&type=script&lang=js"
export * from "./activityResultsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-align/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports